'use strict';
;(function($, window, document){

	// ----------------------------------- Start : Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws;

	// 取得Window設定值
	var windowSetting = function(){
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();

	// 取得裝置判斷
	// isMobile 判斷
	var isMobile = false;
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
		isMobile = true
	}

	var isPhone = ww <= 639;
	var isTable = ww <= 1023;
	// ----------------------------------- End : Setting

	


	// ------------------------------------------ Start: Swiper breakpoint Detected

	// keep track of swiper instances to destroy later
	var mySwiperItem2 = undefined;
	var mySwiperItem3 = undefined;

	// ----------------------
	// Swiper breakpoint Detected
	var breakpoint_medium = window.matchMedia('(min-width:1024px)');

	var breakpointChecker_medium = function() {
		// if larger viewport and multi-row layout needed
		if (breakpoint_medium.matches === true) {
			// clean up old instances and inline styles when available
			if (mySwiperItem2 !== undefined) mySwiperItem2.destroy(true, true);
			
			// 修正如果不是<a>Tag 卻要Hover樣式的智慧型裝置Bug(針對iOS系統)
			if (isMobile){
				$('#standard-preface-slider').addClass('can-click');
			}else{
				$('#standard-preface-slider').removeClass('can-click');
			}

			if (mySwiperItem3 !== undefined) mySwiperItem3.destroy(true, true);
			return;
		} else if (breakpoint_medium.matches === false) {
			return enableSwiper_medium();
		}
	};
	
	// Add Swiper buildHandler
	var enableSwiper_medium = function() {
		buildSwiperItem2();
		buildSwiperItem3();
	};

	// keep an eye on viewport size changes
	breakpoint_medium.addListener(breakpointChecker_medium);

	// start
	registerListener('load', breakpointChecker_medium);


	// -------------------------------------------
	// Standard Dishes
	// Swiper Setting
	function buildSwiperItem2(){
		var SwiperItem2 = '#standard-preface-slider';
		var SwiperItem2BtnNext = $(SwiperItem2).children('.swiper-button-next');
		var SwiperItem2BtnPrev = $(SwiperItem2).children('.swiper-button-prev');
		
		if($(SwiperItem2).length <= 0) return false;

		mySwiperItem2 = new Swiper(SwiperItem2, {
			speed: 400,
			// loop: true,
			autoHeight: true,
			spaceBetween: 100,
			slidesPerView: 'auto',
			centeredSlides: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: SwiperItem2BtnNext,
				prevEl: SwiperItem2BtnPrev,
			},
			breakpoints: {
				639: {
					spaceBetween: 30
				},
			}
		});
	};


	// ------------------------------------------- Start : What we can do
	// What we can do
	function buildSwiperItem3(){
		var SwiperItem3 = '#standard-what-slider';
		var SwiperItem3BtnNext = $(SwiperItem3).children('.swiper-button-next');
		var SwiperItem3BtnPrev = $(SwiperItem3).children('.swiper-button-prev');
		
		if($(SwiperItem3).length <= 0) return false;

		mySwiperItem3 = new Swiper(SwiperItem3, {
			speed: 400,
			autoHeight: true,
			spaceBetween: 30,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: SwiperItem3BtnNext,
				prevEl: SwiperItem3BtnPrev,
			},
			breakpoints: {
				// when window width is <= 639px
				639: {
					slidesPerView: 1,
				},
				// when window width is <= 1199px
				1023: {
					slidesPerView: 'auto',
					centeredSlides: true
				}
			},
		});
	};

	// ------------------------------------------- End : What we can do
	

	
})(jQuery, window, document);